export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13018.68b4f113.jpg";